/**
 * NotesFieldButton - Additional notes field button using existing hooks
 */

import {useAdditionalNotes} from '@hconnect/tuc-processes/fields/textField'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {getTranslatedErrorMessage} from '../../../../../orderIntake'
import {FieldButton} from '../../FieldButton'

interface NotesFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const NotesFieldButton: React.FC<NotesFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {additionalNotes, error} = useAdditionalNotes()

  // Following useRmcOrderEditLogic withFallback pattern
  const trimmed = additionalNotes?.toString().trim()
  const displayValue = trimmed && trimmed.length > 0 ? trimmed : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.additionalNotes', 'Additional notes')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
      error={getTranslatedErrorMessage(error, t)}
    />
  )
}
